var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 446.12 530.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #0e1d25;\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 223.06,
    cy: 329.56,
    fx: 223.06,
    fy: 329.56,
    r: 67.42,
    gradientTransform: "translate(0 263.65) scale(1 .2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#231f20",
    stopOpacity: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#231f20",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M278.66,221.65c0,25.29-37.7,79.12-51.01,97.35-2.27,3.11-6.91,3.11-9.18,0-13.32-18.23-51.01-72.06-51.01-97.35,0-30.71,24.9-55.6,55.6-55.6s55.6,24.9,55.6,55.6Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M236.18,212.82l-6.8,7.42c6.28,5.75,6.7,15.5.95,21.78-5.75,6.28-15.5,6.7-21.78.95l-6.8,7.42c10.37,9.51,26.49,8.8,35.99-1.57,9.51-10.37,8.8-26.49-1.57-35.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M209.94,232.2l6.8-7.42c-6.28-5.75-6.7-15.5-.95-21.78,5.75-6.28,15.5-6.7,21.78-.95l6.8-7.42c-10.37-9.51-26.49-8.8-35.99,1.57-9.51,10.37-8.8,26.49,1.57,35.99Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocator);
export default __webpack_public_path__ + "static/media/locator.ee3a18d3292c174a7a76900ae65aa612.svg";
export { ForwardRef as ReactComponent };